'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_Aisle(name) {
  this.q0 = null;
  this.q0 = name;
}
export { $c_Lmealorama_Aisle as $c_Lmealorama_Aisle };
$p = $c_Lmealorama_Aisle.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Aisle;
/** @constructor */
function $h_Lmealorama_Aisle() {
}
export { $h_Lmealorama_Aisle as $h_Lmealorama_Aisle };
$h_Lmealorama_Aisle.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-506556059), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lmealorama_Aisle) && (this.q0 === x$0.q0)));
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "Aisle";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.q0;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_Aisle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jg)));
}
export { $isArrayOf_Lmealorama_Aisle as $isArrayOf_Lmealorama_Aisle };
var $d_Lmealorama_Aisle = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Aisle, "mealorama.Aisle", ({
  jg: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_Aisle as $d_Lmealorama_Aisle };
//# sourceMappingURL=mealorama.-Aisle.js.map
